import { useState } from 'react'
import { useFormStatus } from 'react-dom'
import { useActionState } from 'react'
import Link from 'next/link'
import countries from '@/data/countries'
import Label from '@/components/common/Label'
import Panel from '@/components/common/Panel'
import { className } from '@/components/common/styles'
import { isIterableArray } from '@/lib/helpers'
import { createTodo } from '@/app/actions'
import { initialState } from '@/app/actions-state'

const verifyVatID = () => {
  console.log('verifyVatID(): not implemented!')
}

const AccountAccount = ({ className }: { className: string }) => {
  const [state, formAction] = useActionState(createTodo, initialState)
  const { pending } = useFormStatus()
  const [companyName, setCompanyName] = useState('Smart Bits')
  const [vatID, setVatID] = useState('NL855308760B01')
  const [companyType, setCompanyType] = useState('EL-2')
  const [fullStreetAddress, setFullStreetAddress] = useState(
    't/o Jacob van Lennepkade 145bis',
  )
  const [city, setCity] = useState('Amsterdam')
  const [postalCode, setPostalCode] = useState('1053AB')
  const [provinceStateCounty, setProvinceStateCounty] =
    useState('North-Holland')
  const [country, setCountry] = useState('Netherlands')

  return (
    <div className={`p-4 ${className}`}>
      <Panel title="Account">
        <form
          //onSubmit={handleAccountSettings}
          action={formAction}
          //method="post"
        >
          <div className="grid grid-cols-2 gap-x-8">
            <div className="col-span-2">
              <Label
                id="company-name"
                label="Company/Organization name"
                type="text"
                value={companyName}
                onChange={({ target }) =>
                  setCompanyName((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="vat-id"
                label="VAT number"
                tooltip="VAT number was last verified on 2019-11-16."
                icon="check-circle"
                iconcolor="text-success"
                ttid="tt-vat-id"
                button="Verify VAT number"
                buttonaction={verifyVatID}
                value={vatID}
                onChange={({ target }) =>
                  setVatID((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="company-type"
                label="Company type"
                tooltip="Company type is applicable only and mandatory for companies registered in Spain or Greece."
                icon="info-circle"
                iconcolor="text-primary"
                ttid="tt-company-type"
                value={companyType}
                onChange={({ target }) =>
                  setCompanyType((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="full-street-address"
                label="Full street address"
                value={fullStreetAddress}
                onChange={({ target }) =>
                  setFullStreetAddress((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="city"
                label="City/Town"
                value={city}
                onChange={({ target }) =>
                  setCity((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="postal-code"
                label="ZIP/Postal code"
                value={postalCode}
                onChange={({ target }) =>
                  setPostalCode((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="province-state-county"
                label="State/Province/Territory/County"
                value={provinceStateCounty}
                onChange={({ target }) =>
                  setProvinceStateCounty((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="country"
                label="Country/Region"
                value={country}
                type="select"
                populate={
                  isIterableArray(countries) &&
                  countries.map((country) => (
                    <option value={country} key={country}>
                      {country}
                    </option>
                  ))
                }
                onChange={({ target }) =>
                  setCountry((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Read more about why we require this personal information
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-2">
              <button
                className={`${className} float-end`}
                type="submit"
                disabled={pending}
              >
                Update account
              </button>
            </div>
            <output aria-live="polite" className="sr-only">
              {state?.message}
            </output>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default AccountAccount
